import { ArcadeAvatar, ArcadeAvatarProps, ArcadeAvatarSize } from '@cash-design-system/react'
import { Avatar as AvatarProto } from '@cash-web/protos/squareup/franklin/ui.pb'

export const getArcadeAvatarFromAvatarProto = ({ avatarProto }: { avatarProto: AvatarProto }): ArcadeAvatarProps => {
  const arcadeAvatarProps: ArcadeAvatarProps = {}
  if (avatarProto.accent_color) {
    arcadeAvatarProps['backgroundColor'] = {
      light: avatarProto.accent_color,
      dark: avatarProto.dark_theme_accent_color ?? avatarProto.accent_color,
    }
  }

  // Display priority: icon > image > monogram_text
  if (avatarProto.icon?.arcade_id) {
    arcadeAvatarProps['icon'] = {
      arcadeId: avatarProto.icon.arcade_id,
    }
  } else if (avatarProto.image_url) {
    arcadeAvatarProps['image'] = {
      lightUrl: avatarProto.image_url,
      darkUrl: avatarProto.dark_theme_image_url ?? avatarProto.image_url,
    }
  } else {
    arcadeAvatarProps['initial'] = avatarProto.initial
  }

  if (avatarProto.colorize_image) {
    arcadeAvatarProps['colorizeImage'] = true
  }

  return arcadeAvatarProps
}

export const ArcadeAvatarFromAvatarProto = ({
  avatarProto = {},
  size,
  disabled,
}: {
  avatarProto?: AvatarProto
  size?: ArcadeAvatarSize
  disabled?: boolean
}) => {
  const arcadeAvatarProps = getArcadeAvatarFromAvatarProto({ avatarProto })
  return <ArcadeAvatar {...arcadeAvatarProps} disabled={disabled} size={size} />
}
